module.exports = __webpack_public_path__ + "static/media/05.6320d3e9.mp3";